import { motion } from "framer-motion";
import podImage from "../assets/pod-design.png";

// Version 4: Bold statement, urgency-driven with different hook
const PartnerAd4 = () => {
  return (
    <div className="h-screen bg-background flex flex-col items-center justify-between px-6 py-8 overflow-hidden relative">
      {/* Subtle background glow */}
      <div 
        className="absolute inset-0 pointer-events-none opacity-[0.03]"
        style={{
          background: "radial-gradient(circle at 50% 30%, hsl(var(--foreground)) 0%, transparent 60%)"
        }}
      />

      {/* Top: Different hook - problem-focused */}
      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.1 }}
        className="text-center mt-6"
      >
        <p className="text-foreground text-2xl font-medium leading-snug">
          That empty corner?
        </p>
        <p className="text-muted-foreground text-lg mt-1">
          It could be earning you
        </p>
      </motion.div>

      {/* Center content */}
      <div className="flex flex-col items-center">
        {/* THE MONEY - extra emphasis */}
        <motion.div
          initial={{ opacity: 0, scale: 0.85 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.35, type: "spring", stiffness: 100 }}
          className="text-center relative"
        >
          <p className="font-funnel text-7xl font-bold text-foreground">£3,000</p>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3, delay: 0.6 }}
            className="text-muted-foreground text-lg"
          >
            every single month
          </motion.p>
        </motion.div>

        {/* Pod with context */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.8, type: "spring", stiffness: 80 }}
          className="flex flex-col items-center mt-6"
        >
          <img
            src={podImage}
            alt="qwip soundproof pod"
            className="w-28 drop-shadow-xl"
          />
          <p className="text-foreground text-base font-medium mt-3">
            1m² qwip pod
          </p>
        </motion.div>

        {/* Benefits row */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.35, delay: 1.05 }}
          className="flex flex-col items-center gap-2 mt-5"
        >
          <div className="flex gap-2">
            <span className="bg-foreground/10 text-foreground text-xs font-medium px-3 py-1.5 rounded-full">
              Zero upfront cost
            </span>
            <span className="bg-foreground/10 text-foreground text-xs font-medium px-3 py-1.5 rounded-full">
              We handle everything
            </span>
          </div>
        </motion.div>
      </div>

      {/* Bottom: Logo and tagline */}
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 1.25 }}
        className="text-center mb-4"
      >
        <span className="font-funnel text-2xl font-bold text-foreground">qwip</span>
        <p className="font-cormorant italic text-foreground/80 text-lg font-semibold mt-1">
          bookable, quiet pods - wherever you go.
        </p>
      </motion.div>
    </div>
  );
};

export default PartnerAd4;
